// ABOUTME: Adds or removes a CSS class on the parent element when connected.
// ABOUTME: Used in Turbo Stream responses to toggle visual states on existing DOM elements.

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { add: String, remove: String }

  connect() {
    if (this.hasAddValue) {
      this.element.parentElement.classList.add(this.addValue)
    }
    if (this.hasRemoveValue) {
      this.element.parentElement.classList.remove(this.removeValue)
    }
    this.element.remove()
  }
}
